export default __webpack_public_path__ + "static/media/ndis-icon-round.bb3ed6e1.svg";